export default "__VITE_ASSET__CEMK3H42__"